import React from 'react';
import './App.css';
import {TextureTestWizard} from "./Components/TextureTestWizard/TextureTestWizard";

function App() {
  return (
    <div className="App">
      <TextureTestWizard />
    </div>
  );
}

export default App;
